<template>
  <div class="regist">
    <section>
      <HeadingLv3 text="登録方法をお選びください。" setLabelSlot labelFixed>
        <em>必須</em>
      </HeadingLv3>

      <div class="lineBox">
        <TextBlock class="lineBox_text">
          <p>
            マイページログイン時に使用する情報をお選びいただけます。<br />LINEと連携して登録する場合、次回以降LINEのアカウント情報にてログインが可能になります。
          </p>
        </TextBlock>
        <SnsRegistButtons @click="goToSocialPlus" label="LINEと連携して登録" />
      </div>
      <HrBlock or />
      <Button
        class="mailBtn"
        lightgray
        label="メールアドレスで登録"
        :handleClick="goForward"
      />
    </section>

    <GoalButtons>
      <Button label="戻る" :handleClick="goBack" />
    </GoalButtons>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, SetupContext } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import GoalButtons from '@/components/block/GoalButtons.vue'
import SnsRegistButtons from '@/components/block/SnsRegistButtons.vue'
import TextBlock from '@/components/block/TextBlock.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'
import HrBlock from '@/components/elements/HrBlock.vue'

function getMemberTypeFromStorage(): string {
  const str = localStorage.getItem('userSelection')
  const parsed = str ? JSON.parse(str) : {}
  return `${parsed.hopeMemberType || ''}`
}

export default defineComponent({
  name: 'RegisterEventsSelect',

  components: {
    GoalButtons,
    SnsRegistButtons,
    TextBlock,
    HeadingLv3,
    Button,
    HrBlock
  },

  props: {
    data: Object,
    state: {
      type: Object,
      require: true
    }
  },

  setup(props: any, context: SetupContext) {
    const router = useRouter()
    const route = useRoute()
    // 入力ページ経由じゃない場合は弾く
    // if (!props.state.isLandingInput) {
    //   router.replace('/500')
    // }

    // NOTE: ブラウザバックを使用してLINE連携から戻った場合メモリ上のevent_idが揮発することがある
    const eventId = computed(() => {
      return props.data.event_id || route.query.event_id
    })

    const goBack = () => {
      router.push(`/register/events/terms?event_id=${eventId.value}`)
    }

    const goForward = () => {
      // NOTE: メールアドレス登録に移動する前にsocialplus_idを削除
      context.emit('update-profile', 'socialplus_id', '')
      router.push(`/register/events/profile?event_id=${eventId.value}`)
    }

    const goToSocialPlus = () => {
      localStorage.setItem(
        'userSelection',
        `${JSON.stringify({
          hopeKeywords: props.data.hopeKeywords,
          hopeMemberType: props.data.memberType,
          hopePrefectures: props.data.hopePrefectures,
          invitationCode: props.data.invitationCode,
          event_id: eventId.value
        })}`
      )
      location.href = `https://ca68f31f7a.auth.socialplus.jp/mynavi_resident/mynavi_resident_usr/line/authenticate?callback=${process.env.VUE_APP_URL}/register/events/profile?event_id=${props.data.event_id}&extended_items=real_name,gender,birthdate,address,email,phone`
    }

    onMounted(() => {
      context.emit('update-flow', 3)

      // NOTE: メモリ上にmemberTypeがない場合はlocalStorageから再取得を試みる
      if (props.data.memberType) return
      context.emit('update-member-type', getMemberTypeFromStorage())
    })

    return {
      goBack,
      goForward,
      goToSocialPlus
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.lineBox {
  margin-top: 14px;
  @include mixins.media() {
    margin-top: 19px;
  }
  &_text {
    margin-bottom: 40px;
  }
}
.mailBtn {
  max-width: 303px;
}
</style>
